import isCircuitWorkoutSectionUtil from '../../../model/utils/is-circuit'
import getCurrentWorkoutSectionSelector from '../get-current'
import { createSelector } from 'reselect'

const isCircuitWorkoutSectionSelector = createSelector(
  getCurrentWorkoutSectionSelector,
  (instance) => isCircuitWorkoutSectionUtil(instance)
)

export default isCircuitWorkoutSectionSelector
